import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';

const DealTileTabSelect = (): React.ReactElement | null => {
  const { tabs, selectedTab, onProductChange } = useProductsContext();

  if (tabs.length <= 1) {
    return null;
  }

  const options: ISelectOption[] = tabs.map((tab) => ({
    label: tab.name,
    value: tab.id,
  }));

  const value = options.find((o) => o.value === selectedTab?.id) || options[0];

  const handleChange = (option: ISelectOption): void => {
    if (option) {
      onProductChange(option.value as string);
    }
  };

  return (
    <Select
      value={ value }
      options={ options }
      onChange={ handleChange }
      isSlim
      isNarrow
      isSearchable={ false }
      size="S"
      dataTest="dealTileProductTabSelect"
    />
  );
};

export default DealTileTabSelect;
